module.exports = __webpack_public_path__ + "static/media/category-top-bg.664d710f.svg";